export default __webpack_public_path__ + "assets/svg.21a77099744d94b9214c52043ef39d95.png";